/** Shared political party colors for forecast charts and the power index. */
export const REPUBLICAN_COLOR = '#ff3333';
export const DEMOCRATIC_COLOR = '#265cff';
export const SPLIT_CONTROL_COLOR = '#aa00ff';

/**
 * Lighter tints of the party hues for TEXT on dark surfaces, where the saturated pair reads at 3.6:1 (red) and 2.5:1
 * (blue); both of these clear 4.5:1 on the dark theme's surfaces. Lines and fills keep the saturated pair.
 */
export const REPUBLICAN_TEXT_COLOR_ON_DARK = '#ff6b6b';
export const DEMOCRATIC_TEXT_COLOR_ON_DARK = '#7a9cff';

/** Balance of Power chart lines, keyed by `getBalanceOfPowerColorKey`'s outcome. */
export const BALANCE_OF_POWER_COLORS = {
    Red: REPUBLICAN_COLOR,
    Blue: DEMOCRATIC_COLOR,
    Purple: SPLIT_CONTROL_COLOR,
} as const;
